import React, { Suspense } from 'react';
import { renderIntoContainer, unmountContainer } from 'react/root/containerRoot';
import { Provider } from 'react-redux';
import MainChatHolder from 'react/chat/MainChatHolder'; // ?!?!!?! needed to be loaded here for now
import { Match } from 'models/Match';
import { privateChatMessageHolder } from 'components/PrivateChatMessageHolder';
import { matchSearchListManager } from 'components/MatchSearchListManager';
import { Dashboard } from 'components/Dashboard';

import store from 'react/redux/store/store';
import PopupCards from './stream/PopupCards';

const RecentRankedSets = React.lazy(() => import(/* webpackChunkName: "RecentRankedSets" */ 'react/match/RecentRankedSets'));
const ReportMatchPicker = React.lazy(() => import(/* webpackChunkName: "ReportMatchPicker" */ 'react/bugs/ReportMatchPicker'));
const ReportHeadToHead = React.lazy(() => import(/* webpackChunkName: "ReportHeadToHead" */ 'react/bugs/ReportHeadToHead'));
const InfractionForm = React.lazy(() => import(/* webpackChunkName: "InfractionForm" */ './mod/InfractionForm.jsx'));
import { Users } from 'models/UserCollection';
import InfractionList from './mod/InfractionList';
import Infraction from '../models/Infraction';
import LadderSuspense from "./elements/LadderSuspense.jsx";
import LoaderFullPage from "./elements/LoaderFullPage.jsx";
import mountNotifications from 'react/notifications/mountNotifications';

class ReactChat {
	static cachedSelectors = new Map();
	static chatSidebarOpen = false;
	static initialized = false;

	static updatePopupContainers() {
		ReactChat.render(
			(
				<Provider store={store}>
					<PopupCards />
				</Provider>
			),
			'#popout_cards'
		);
	}

	static injectInfractionForm(elementId) {
		const element = _.isElement(elementId) ? elementId : document.getElementById(elementId);
		const reportId = JSON.parse(element.getAttribute('data-report_id'));
		const infraction = JSON.parse(element.getAttribute('data-infraction'));
		const user = JSON.parse(element.getAttribute('data-user'));
		const players = JSON.parse(element.getAttribute('data-players'));
		const player = Users.update(user);
		const matchId = JSON.parse(element.getAttribute('data-match_id'));
		const chatRoomId = JSON.parse(element.getAttribute('data-chat_room_id'));

		ReactChat.render(
			<Provider store={store}>
				<LadderSuspense>
					<InfractionForm
						reportId={reportId}
						players={players ? players.map((player) => {
							return Users.update(player);
						}) : [player]}
						infraction={infraction && infraction.id ? Infraction.create(infraction) : null}
						matchId={matchId}
						chatRoomId={chatRoomId}
					/>
				</LadderSuspense>
			</Provider>,
			element
		);
	}

	static renderInfractionList(elementId) {
		const element = _.isElement(elementId) ? elementId : document.getElementById(elementId);
		const playerId = JSON.parse(element.getAttribute('data-player_id'));
		const reportId = JSON.parse(element.getAttribute('data-report_id'));
		ReactChat.render(
			<Provider store={store}>
				<InfractionList
					reportId={reportId}
					playerId={playerId}
				/>
			</Provider>
			,
			element
		);
	}

	// A direct-message report's head-to-head on the report page, for mods.
	static renderReportHeadToHead(elementId) {
		const element = document.getElementById(elementId);
		const player = Users.update(JSON.parse(element.getAttribute('data-player')));
		const againstPlayer = Users.update(JSON.parse(element.getAttribute('data-against_player')));
		ReactChat.render(
			<LadderSuspense>
				<ReportHeadToHead player={player} againstPlayer={againstPlayer} />
			</LadderSuspense>,
			element
		);
	}

	// The report form's "In a match" step: the reporter's recent sets with the
	// reported player, calling onSelect with the id of the one picked.
	static renderReportMatchPicker(elementId, onSelect) {
		const element = document.getElementById(elementId);
		const player = Users.update(JSON.parse(element.getAttribute('data-player')));
		const otherPlayer = Users.update(JSON.parse(element.getAttribute('data-other_player')));
		ReactChat.render(
			<LadderSuspense>
				<ReportMatchPicker player={player} otherPlayer={otherPlayer} onSelect={onSelect} />
			</LadderSuspense>,
			element
		);
	}

	// /match/history's list of the newest ranked sets site-wide.
	static renderRecentRankedSets(elementId) {
		const element = document.getElementById(elementId);
		ReactChat.render(
			<LadderSuspense>
				<RecentRankedSets seasonId={JSON.parse(element.getAttribute('data-season_id'))} />
			</LadderSuspense>,
			element
		);
	}

	static render(component, id) {
		const selector = ReactChat.retrieveElementFromSelector(id);
		if(!selector) {
			return null;
		}
		// Called from React lifecycles (MatchmakingMain mounts the sidebar and notification
		// bar this way), where a synchronous flush isn't possible.
		renderIntoContainer(component, selector, { sync: false });
	}

	static unrender(id) {
		const selector = ReactChat.retrieveElementFromSelector(id, true);
		if(!selector) {
			return;
		}
		console.log('removing at', selector);
		unmountContainer(selector);
	}

	static retrieveElementFromSelector(id, deleteFound = false) {
		let selector = null;
		if(ReactChat.cachedSelectors.get(id) !== undefined) {
			selector = ReactChat.cachedSelectors.get(id);
		}
		else {
			selector = _.isElement(id) ? id : document.getElementById(id.substring(1));
			if(selector) {
				ReactChat.cachedSelectors.set(id, selector);
			}
			else {
				console.warn(`Selector not found ${id}`);
				return null;
			}
		}
		if(deleteFound) {
			ReactChat.cachedSelectors.delete(id);
		}
		if(!selector) {
			console.error('NO SELECTOR FOR');
			console.error(id);
			return null;
		}
		return selector;
	}
}

setTimeout(() => {
	mountNotifications();
	ReactChat.updatePopupContainers();
}, 1000);

export { ReactChat };

window.ReactChat = ReactChat;